import Banner from './banner';
import Company from './company';
import Jobda from './jobda';
import Competency from './competency';
import Question from './question';
import AI from './ai';
import ResultLink from './resultLink';
import classnames from 'classnames/bind';
import styles from './introduce.module.scss';
const cx = classnames.bind(styles);

const Introduce = () => {
  return (
    <div className={cx('wrap')}>
      <Banner />
      <Company />
      <Jobda />
      <Competency />
      <Question />
      <AI />
      <ResultLink />
    </div>
  );
};

export default Introduce;
